import { financialSummaryConfig } from "./common-attributes";
import { AgreementTagType, AgreementTemplateInput, TreatmentPriceInput } from "./graphql";

export const versioningTemplateVars = {
	input: {
		version: 1,
		name: "Version check model",
		subjectMatter: "DRUGS",
		isCaseless: false,
		currencyCode: "CHF",
		validFromDate: "2020-01-01",
		allowedForms: ["CR-0000000001"],
		requiredForms: ["CR-0000000001"],
		isChildAgreementCreationAllowed: true,
		deviceAlternativeSets: [],
		hasAlternatives: false,
		allowedRecords: ["RE-0000000001"],
		requiredRecords: [],
		cycles: [],
		isAllowedFormsEnabled: true,
		isRequiredFormsEnabled: true,
		isAllowedRecordsEnabled: true,
		isRequiredRecordsEnabled: false,
		isCoveringIntervalEnabled: true,
		enrollingConditionSets: [
			{
				order: 0,
				conditions: [],
				scopes: [
					{
						scopeId: "AS-0000000867",
						countryScopes: [
							{
								name: "Switzerland",
								countryScopeIds: [],
							},
						],
						organizationScopes: [],
						order: 0,
						logicalOperator: "AND",
						code: "D:H18.83;I:Recurrent - combined with dexamethasone - 2L - 3L;TS:G:liuba_generic,FIXED TARGET:false,P:999913,T:9999999999991;AND",
						diseases: [
							{
								Name: "Recurrent erosion of cornea",
								Icd10Code: "H18.83",
								Score: null,
							},
						],
						indications: [
							{
								code: "Recurrent - combined with dexamethasone - 2L - 3L",
								id: "IN-0000000058",
								type: "Recurrent",
								intent: "combined with dexamethasone",
								line: "2L - 3L",
								mutation: null,
								typeLocalizationKey: "indication_type_recurrent",
								intentLocalizationKey: "indication_intent_combinedWithDexamethasone",
								lineLocalizationKey: "indication_line_2l_3l",
								mutationLocalizationKey: null,
							},
						],
						treatmentSets: [
							{
								order: 0,
								generic: "liuba_generic",
								preparations: [
									{
										id: "999913",
										AtcCode: "G99XA1",
										BrandName: "liuba_prep",
									},
								],
								treatments: [
									{
										Code: "99113",
										GTIN: "9999999999991",
										UDI: "",
										Name: "10 Freeflex 300 ml",
										SwissmedicNo8: "999999991",
									},
								],
								isFixedPriceTarget: false,
							},
						],
						isDeleted: false,
					},
				],
				isIndicationNotEnrollingCondition: null,
				isDiseaseNotEnrollingCondition: null,
			},
		],
		eligibilityConditionSets: [],
		treatmentPrices: [
			{
				treatment: {
					Code: "99113",
					UDI: "",
					GTIN: "9999999999991",
					Name: "10 Freeflex 300 ml",
					SwissmedicNo8: "999999991",
					activeIngredientQuantity: null,
					uoMType: null,
				},
				price: 1200,
				basePriceType: "CUSTOM_PRICE_PERCENT",
			} as unknown as TreatmentPriceInput,
		],
		scenarios: [
			{
				order: 0,
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "PRESCRIPTION_NUMBER",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "GREATER_THEN_OR_EQUAL",
						bothOperatorFirst: null,
						bothOperatorSecond: null,
						value: 4,
						endRangeValue: null,
						brandNames: ["liuba_prep"],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: "PACK",
						deltaType: null,
						monitoringType: null,
						startingPoint: null,
						timeframeRangeType: "EVER",
						timeframeRelation: null,
						timeframeStart: null,
						timeframeEnd: null,
						countdownPoint: null,
						comparedStartingPoint: null,
						comparedTimeframeRangeType: null,
						comparedTimeframeRelation: null,
						comparedTimeframeStart: null,
						comparedTimeframeEnd: null,
						comparedCountdownPoint: null,
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 15,
						priceType: "CUSTOM_PRICE_PERCENT",
						itemScope: "ALL",
						itemRangeType: null,
						startItemNumber: null,
						endItemNumber: null,
						timeframeRangeType: "WITHIN_THE_COVERAGE_PERIOD",
						timeframeStart: null,
						timeframeEnd: null,
						timeframeRelation: null,
						startingPoint: null,
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [{ name: "liuba_prep", order: 0 }],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
					},
				],
			},
		],
		defaultPriceRate: 100,
		childAgreementsDefaultStatus: null,
		financialSummaryConfig,
		ldlChartConfig: [],
		dotChartConfig: [],
		dotThresholds: [],
		expectedDocument: "INVOICE",
		validToDate: "2020-12-31",
		id: null,
		limitationId: null,
		caseSuspensionIntervalDays: 0,
		coveringFormWaitInterval: null,
		enrolmentDateType: "FIRST_RECORD_DATE",
		enrollingPeriod: null,
		negotiableAttributeIds: [],
		treatmentNames: "liuba_prep",
		initialVersionId: null,
		scenariosRelevantBrands: [],
		agreementTags: AgreementTagType.Custom,
	} as AgreementTemplateInput,
};

export const repathaModelPayload = {
	input: {
		version: 1,
		name: `E2E Repatha ${new Date().toISOString}`,
		subjectMatter: "DRUGS",
		isCaseless: false,
		currencyCode: "CHF",
		validFromDate: "2021-01-01",
		allowedForms: ["EE-9999999900", "EE-9999999902", "EE-9999999903"],
		requiredForms: ["EE-9999999900"],
		allowedRecords: ["EE-9999999901"],
		deviceAlternativeSets: [],
		hasAlternatives: false,
		requiredRecords: [],
		cycles: [],
		isAllowedFormsEnabled: true,
		isRequiredFormsEnabled: true,
		isAllowedRecordsEnabled: true,
		isRequiredRecordsEnabled: false,
		isCoveringIntervalEnabled: false,
		scenariosRelevantBrands: [],
		enrollingConditionSets: [
			{
				order: 0,
				conditions: [
					{
						conditionType: "PREVIOUS_THERAPY",
						includedGenerics: ["Evolocumabum"],
						inclusionType: "NOT_INCLUDED",
						cycleLimitFrom: null,
						cycleLimitTo: null,
					},
					{
						conditionType: "PATIENT_AGE",
						operator: "GREATER_THEN_OR_EQUAL",
						rangeInputStart: 18,
						cycleLimitFrom: null,
						cycleLimitTo: null,
					},
					{
						conditionType: "LDL_LEVEL",
						timeframeRangeType: "WITHIN",
						timeframeStartingPoint: "FIRST_ADMINISTRATION_DATE",
						resultSelectionType: "HIGHEST",
						timeframeRangeStart: 0,
						timeframeRangeEnd: 90,
						countdownOperator: "BEFORE",
						operator: "GREATER_THEN_OR_EQUAL",
						rangeInputStart: 275,
						cycleLimitFrom: null,
						cycleLimitTo: null,
					},
				],
				scopes: [
					{
						scopeId: "AS-0000000768",
						countryScopes: [
							{
								name: "Switzerland",
								countryScopeIds: [],
							},
						],
						organizationScopes: [],
						order: 0,
						logicalOperator: "AND",
						code: "D:A32.8;I:Early - Monotherapy - 3L;TS:G:Evolocumabum,FIXED TARGET:false,P:28440,T:7680656220019,7680656220026;AND",
						diseases: [
							{
								Name: "Other forms of listeriosis",
								Icd10Code: "A32.8",
								Score: null,
							},
						],
						indications: [
							{
								code: "Early - Monotherapy - 3L",
								id: "IN-0000000208",
								type: "Early",
								intent: "Monotherapy",
								line: "3L",
								mutation: null,
								typeLocalizationKey: "indication_type_early",
								intentLocalizationKey: "indication_intent_monotherapy",
								lineLocalizationKey: "indication_line_3l",
								mutationLocalizationKey: null,
							},
						],
						treatmentSets: [
							{
								order: 0,
								generic: "Evolocumabum",
								preparations: [
									{
										id: "28440",
										AtcCode: "C10AX13",
										BrandName: "Repatha",
									},
								],
								treatments: [
									{
										Code: "36184",
										GTIN: "7680656220019",
										UDI: "",
										Name: "1 Stk",
										SwissmedicNo8: "65622001",
									},
									{
										Code: "36185",
										GTIN: "7680656220026",
										UDI: "",
										Name: "2 Stk",
										SwissmedicNo8: "65622002",
									},
								],
								isFixedPriceTarget: false,
							},
						],
						isDeleted: false,
					},
				],
			},
		],
		eligibilityConditionSets: [
			{
				name: "7",
				minimumPercentage: 80,
				days: 90,
				code: "7",
			},
			{
				name: "9",
				treatments: ["7680656220019", "7680656220026"],
				numberOfAdministeredRangeDays: [70, 90],
				numberOfAdministeredTreatments: 6,
				numberOfAdministeredTreatmentsOperator: "GREATER_THEN_OR_EQUAL",
				code: "9",
			},
			{
				name: "8",
				previousTestNumber: 2,
				referenceTestRangeDays: [0, 90],
				referenceAdministrationSequenceNumber: 1,
				code: "8",
			},
		],
		treatmentPrices: [
			{
				treatment: {
					Code: "36184",
					UDI: "",
					GTIN: "7680656220019",
					Name: "1 Stk",
					SwissmedicNo8: "65622001",
					activeIngredientQuantity: 25,
					uoMType: "MILLIGRAM",
				},
				price: 188.96,
				basePriceType: "EX_FACTORY_PRICE_PERCENT",
			} as unknown as TreatmentPriceInput,
			{
				treatment: {
					Code: "36185",
					UDI: "",
					GTIN: "7680656220026",
					Name: "2 Stk",
					SwissmedicNo8: "65622002",
					activeIngredientQuantity: 50,
					uoMType: "MILLIGRAM",
				},
				price: 377.92,
				basePriceType: "EX_FACTORY_PRICE_PERCENT",
			},
		],
		scenarios: [
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "LDL_LEVEL",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "LESS_THEN_OR_EQUAL",
						bothOperatorFirst: null,
						bothOperatorSecond: null,
						value: 30,
						endRangeValue: null,
						brandNames: [],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: null,
						deltaType: "NEGATIVE",
						monitoringType: "CHANGED_BETWEEN",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						timeframeRangeType: "WITHIN",
						timeframeRelation: "BEFORE",
						timeframeStart: 0,
						timeframeEnd: 90,
						countdownPoint: "HIGHEST",
						comparedStartingPoint: "FIRST_ADMINISTRATION_DATE",
						comparedTimeframeRangeType: "WITHIN",
						comparedTimeframeRelation: "STARTING_FROM",
						comparedTimeframeStart: 60,
						comparedTimeframeEnd: 90,
						comparedCountdownPoint: "HIGHEST",
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 100,
						priceType: "EX_FACTORY_PRICE_PERCENT",
						itemScope: "SPECIFIC",
						itemRangeType: "WITHIN",
						startItemNumber: 1,
						endItemNumber: 6,
						timeframeRangeType: "WITHIN",
						timeframeStart: 0,
						timeframeEnd: 90,
						timeframeRelation: "STARTING_FROM",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [
							{
								name: "Repatha",
								order: 0,
							},
						],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
						isSortedByPackOrder: null,
					},
				],
				order: 0,
			},
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "LDL_LEVEL",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "BOTH",
						bothOperatorFirst: "GREATER_THEN_OR_EQUAL",
						bothOperatorSecond: "LESS_THEN_OR_EQUAL",
						value: 30,
						endRangeValue: 40,
						brandNames: [],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: null,
						deltaType: "NEGATIVE",
						monitoringType: "CHANGED_BETWEEN",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						timeframeRangeType: "WITHIN",
						timeframeRelation: "BEFORE",
						timeframeStart: 0,
						timeframeEnd: 90,
						countdownPoint: "HIGHEST",
						comparedStartingPoint: "FIRST_ADMINISTRATION_DATE",
						comparedTimeframeRangeType: "WITHIN",
						comparedTimeframeRelation: "STARTING_FROM",
						comparedTimeframeStart: 60,
						comparedTimeframeEnd: 90,
						comparedCountdownPoint: "HIGHEST",
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 50,
						priceType: "EX_FACTORY_PRICE_PERCENT",
						itemScope: "SPECIFIC",
						itemRangeType: "WITHIN",
						startItemNumber: 1,
						endItemNumber: 6,
						timeframeRangeType: "WITHIN",
						timeframeStart: 0,
						timeframeEnd: 90,
						timeframeRelation: "STARTING_FROM",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [
							{
								name: "Repatha",
								order: 0,
							},
						],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
						isSortedByPackOrder: null,
					},
				],
				order: 1,
			},
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "LDL_LEVEL",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "BOTH",
						bothOperatorFirst: "GREATER_THEN_OR_EQUAL",
						bothOperatorSecond: "LESS_THEN_OR_EQUAL",
						value: 40,
						endRangeValue: 50,
						brandNames: [],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: null,
						deltaType: "NEGATIVE",
						monitoringType: "CHANGED_BETWEEN",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						timeframeRangeType: "WITHIN",
						timeframeRelation: "BEFORE",
						timeframeStart: 0,
						timeframeEnd: 90,
						countdownPoint: "HIGHEST",
						comparedStartingPoint: "FIRST_ADMINISTRATION_DATE",
						comparedTimeframeRangeType: "WITHIN",
						comparedTimeframeRelation: "STARTING_FROM",
						comparedTimeframeStart: 60,
						comparedTimeframeEnd: 90,
						comparedCountdownPoint: "HIGHEST",
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 30,
						priceType: "EX_FACTORY_PRICE_PERCENT",
						itemScope: "SPECIFIC",
						itemRangeType: "WITHIN",
						startItemNumber: 1,
						endItemNumber: 6,
						timeframeRangeType: "WITHIN",
						timeframeStart: 0,
						timeframeEnd: 90,
						timeframeRelation: "STARTING_FROM",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [
							{
								name: "Repatha",
								order: 0,
							},
						],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
						isSortedByPackOrder: null,
					},
				],
				order: 2,
			},
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "LDL_LEVEL",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "GREATER_THEN_OR_EQUAL",
						bothOperatorFirst: null,
						bothOperatorSecond: null,
						value: 51,
						endRangeValue: null,
						brandNames: [],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: null,
						deltaType: "NEGATIVE",
						monitoringType: "CHANGED_BETWEEN",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						timeframeRangeType: "WITHIN",
						timeframeRelation: "BEFORE",
						timeframeStart: 0,
						timeframeEnd: 90,
						countdownPoint: "HIGHEST",
						comparedStartingPoint: "FIRST_ADMINISTRATION_DATE",
						comparedTimeframeRangeType: "WITHIN",
						comparedTimeframeRelation: "STARTING_FROM",
						comparedTimeframeStart: 60,
						comparedTimeframeEnd: 90,
						comparedCountdownPoint: "HIGHEST",
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 0,
						priceType: "EX_FACTORY_PRICE_PERCENT",
						itemScope: "SPECIFIC",
						itemRangeType: "WITHIN",
						startItemNumber: 1,
						endItemNumber: 6,
						timeframeRangeType: "WITHIN",
						timeframeStart: 0,
						timeframeEnd: 90,
						timeframeRelation: "STARTING_FROM",
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [
							{
								name: "Repatha",
								order: 0,
							},
						],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
						isSortedByPackOrder: null,
					},
				],
				order: 3,
			},
		],
		defaultPriceRate: 100,
		childAgreementsDefaultStatus: null,
		financialSummaryConfig,
		ldlChartConfig: [],
		dotChartConfig: [],
		dotThresholds: [],
		expectedDocument: "INVOICE",
		id: null,
		limitationId: null,
		caseSuspensionIntervalDays: 0,
		coveringFormWaitInterval: null,
		enrolmentDateType: "FIRST_RECORD_DATE",
		validToDate: "9999-12-31",
		enrollingPeriod: null,
		negotiableAttributeIds: [],
		treatmentNames: "Repatha",
		initialVersionId: null,
		isNewVersion: false,
		isChildAgreementCreationAllowed: false,
		agreementTags: AgreementTagType.Custom,
	} as AgreementTemplateInput,
};

export const cyclesModelPayload = {
	input: {
		name: "E2E Cycle Model 1",
		subjectMatter: "DRUGS",
		isCaseless: false,
		currencyCode: "CHF",
		validFromDate: "2021-01-01",
		allowedForms: ["CR-0000000001", "DN-0000000004"],
		requiredForms: ["CR-0000000001"],
		deviceAlternativeSets: [],
		hasAlternatives: false,
		allowedRecords: ["RE-0000000001"],
		requiredRecords: [],
		negotiableAttributeIds: [],
		cycles: [
			{
				order: 0,
				name: "Cycle 1",
				lengthFrom: 15,
				lengthTo: 20,
				cycleStartingPoint: "PREVIOUS_CYCLE_FIRST_RECORD",
				startingTreatmentCode: "7680367520170",
				startingTreatmentBrandName: "Acidum folicum Streuli",
				startingTreatmentGenericName: "Acidum folicum",
				recordTypeId: "RE-0000000001",
				therapies: [
					{
						cycleToleranceFrom: 1,
						cycleToleranceTo: 1,
						packQuantityFrom: null,
						packQuantityTo: null,
						recordQuantityFrom: null,
						recordQuantityTo: null,
						recordGapFrom: null,
						recordGapTo: null,
						dosageFrom: null,
						dosageTo: null,
						expectedDays: [1, 6, 12],
						genericName: "Acidum folicum",
					},
				],
				scopeCode: "D:H43.811;I:PAF - Cool Intent - 2L;TS:G:Acidum folicum,FIXED TARGET:true,P:9808,T:7680367520170;AND",
			},
		],
		isAllowedFormsEnabled: true,
		isRequiredFormsEnabled: true,
		isAllowedRecordsEnabled: true,
		isRequiredRecordsEnabled: false,
		isCoveringIntervalEnabled: false,
		enrollingConditionSets: [
			{
				order: 0,
				conditions: [
					{
						conditionType: "CYCLE_LIMIT",
						cycleLimitTo: 3,
						cycleLimitFrom: null,
					},
				],
				scopes: [
					{
						scopeId: "",
						countryScopes: [
							{
								name: "Switzerland",
								countryScopeIds: [],
							},
						],
						organizationScopes: [],
						order: 0,
						logicalOperator: "AND",
						code: "D:H43.811;I:PAF - Cool Intent - 2L;TS:G:Acidum folicum,FIXED TARGET:true,P:9808,T:7680367520170;AND",
						diseases: [
							{
								Name: "Vitreous degeneration, right eye",
								Icd10Code: "H43.811",
							},
						],
						indications: [
							{
								code: "PAF - Cool Intent - 2L",
								type: "PAF",
								intent: "Cool Intent",
								line: "2L",
								mutation: null,
							},
						],
						treatmentSets: [
							{
								order: 0,
								generic: "Acidum folicum",
								preparations: [
									{
										id: "9808",
										AtcCode: "B03BB01",
										BrandName: "Acidum folicum Streuli",
									},
								],
								treatments: [
									{
										Code: "14427",
										GTIN: "7680367520170",
										UDI: "",
										Name: "100 Stk",
										SwissmedicNo8: "36752017",
									},
								],
								isFixedPriceTarget: true,
							},
						],
						isDeleted: false,
					},
				],
			},
		],
		eligibilityConditionSets: [
			{
				name: "10",
				cycleAdherence: "SEMI_STRICT",
				code: "10",
			},
		],
		treatmentPrices: [
			{
				treatment: {
					Code: "14427",
					UDI: "",
					GTIN: "7680367520170",
					Name: "100 Stk",
					SwissmedicNo8: "36752017",
					activeIngredientQuantity: null,
					uoMType: null,
				},
				price: 0,
				basePriceType: "PUBLIC_PRICE_PERCENT",
			} as unknown as TreatmentPriceInput,
		],
		scenarios: [
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "PRESCRIPTION_NUMBER",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "GREATER_THEN_OR_EQUAL",
						value: 1,
						endRangeValue: null,
						brandNames: ["Acidum folicum Streuli"],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: "PACK",
						deltaType: null,
						monitoringType: null,
						startingPoint: null,
						timeframeRangeType: "EVER",
						timeframeRelation: null,
						timeframeStart: null,
						timeframeEnd: null,
						countdownPoint: null,
						comparedStartingPoint: null,
						comparedTimeframeRangeType: null,
						comparedTimeframeRelation: null,
						comparedTimeframeStart: null,
						comparedTimeframeEnd: null,
						comparedCountdownPoint: null,
					},
				],
				actions: [
					{
						isAdHocDiscount: false,
						order: 0,
						actionType: "DEDUCT",
						value: 1500,
						priceType: "PUBLIC_PRICE",
						itemScope: "ALL",
						itemRangeType: null,
						startItemNumber: null,
						endItemNumber: null,
						timeframeRangeType: "STARTING_FROM",
						timeframeStart: 0,
						timeframeEnd: null,
						timeframeRelation: "STARTING_FROM",
						startingPoint: "AGREEMENT_START_DATE",
						itemCombinationRule: null,
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: null,
						entityPriceType: "CYCLE",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: 0,
					},
				],
				order: 0,
			},
		],
		defaultPriceRate: 100,
		childAgreementsDefaultStatus: null,
		financialSummaryConfig,
		ldlChartConfig: [],
		dotChartConfig: [],
		expectedDocument: "INVOICE",
		id: null,
		limitationId: null,
		caseSuspensionIntervalDays: 0,
		coveringFormWaitInterval: null,
		enrolmentDateType: "RECORD_DATE",
		validToDate: "9999-12-31",
		enrollingPeriod: null,
		treatmentNames: "Acidum folicum Streuli",
		initialVersionId: null,
		dotThresholds: [],
		scenariosRelevantBrands: [],
		agreementTags: AgreementTagType.Custom,
	} as AgreementTemplateInput,
};

export const creditNoteModelPayload = {
	input: {
		version: 1,
		name: `E2E Test - Credit Note Model ${new Date().toISOString()}`,
		subjectMatter: "DRUGS",
		isCaseless: false,
		currencyCode: "CHF",
		validFromDate: "2021-01-01",
		allowedForms: ["CR-0000000001", "CB-0000000003"],
		requiredForms: ["CR-0000000001"],
		deviceAlternativeSets: [],
		hasAlternatives: false,
		allowedRecords: ["RE-0000000002"],
		requiredRecords: [],
		cycles: [],
		isAllowedFormsEnabled: true,
		isRequiredFormsEnabled: true,
		isAllowedRecordsEnabled: true,
		isRequiredRecordsEnabled: false,
		isCoveringIntervalEnabled: false,
		enrollingConditionSets: [
			{
				order: 0,
				conditions: [],
				scopes: [
					{
						countryScopes: [
							{
								name: "Switzerland",
								countryScopeIds: [],
							},
						],
						organizationScopes: [],
						order: 0,
						logicalOperator: "AND",
						code: "D:W21.05;I:Recurrent;TS:G:Timololum,FIXED TARGET:false,P:10257,T:7680572040012;AND",
						diseases: [
							{
								Name: "Struck by basketball",
								Icd10Code: "W21.05",
							},
						],
						indications: [
							{
								code: "Recurrent",
								id: "IN-0000000060",
								type: "Recurrent",
								intent: null,
								line: null,
								mutation: null,
								typeLocalizationKey: "indication_type_recurrent",
								intentLocalizationKey: null,
								lineLocalizationKey: null,
								mutationLocalizationKey: null,
							},
						],
						treatmentSets: [
							{
								order: 0,
								generic: "Timololum",
								preparations: [
									{
										id: "10257",
										AtcCode: "S01ED01",
										BrandName: "Timogel UD",
									},
								],
								treatments: [
									{
										Code: "15247",
										GTIN: "7680572040012",
										UDI: "",
										Name: "30 Monodos 0.400 g",
										SwissmedicNo8: "57204001",
									},
								],
								isFixedPriceTarget: false,
							},
						],
						isDeleted: false,
					},
				],
			},
		],
		eligibilityConditionSets: [],
		treatmentPrices: [
			{
				treatment: {
					Code: "15247",
					UDI: "",
					GTIN: "7680572040012",
					Name: "30 Monodos 0.400 g",
					SwissmedicNo8: "57204001",
					activeIngredientQuantity: null,
					uoMType: null,
				},
				price: 16.3,
				basePriceType: "PUBLIC_PRICE_PERCENT",
			} as unknown as TreatmentPriceInput,
		],
		scenarios: [
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "PRESCRIPTION_NUMBER",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "GREATER_THEN",
						bothOperatorFirst: null,
						bothOperatorSecond: null,
						value: 1,
						endRangeValue: null,
						brandNames: ["Timogel UD"],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: "PACK",
						deltaType: null,
						monitoringType: null,
						startingPoint: null,
						timeframeRangeType: "EVER",
						timeframeRelation: null,
						timeframeStart: null,
						timeframeEnd: null,
						countdownPoint: null,
						comparedStartingPoint: null,
						comparedTimeframeRangeType: null,
						comparedTimeframeRelation: null,
						comparedTimeframeStart: null,
						comparedTimeframeEnd: null,
						comparedCountdownPoint: null,
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 10,
						priceType: "PUBLIC_PRICE_PERCENT",
						itemScope: "ALL",
						itemRangeType: null,
						startItemNumber: null,
						endItemNumber: null,
						timeframeRangeType: "EVER",
						timeframeStart: null,
						timeframeEnd: null,
						timeframeRelation: null,
						startingPoint: null,
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [{ name: "Timogel UD", order: 0 }],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "PRESCRIBED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
					},
				],
				order: 0,
			},
		],
		defaultPriceRate: 100,
		childAgreementsDefaultStatus: null,
		financialSummaryConfig,
		ldlChartConfig: [],
		dotChartConfig: [],
		dotThresholds: [],
		expectedDocument: "CREDIT_NOTE",
		id: null,
		limitationId: null,
		caseSuspensionIntervalDays: 0,
		coveringFormWaitInterval: null,
		enrolmentDateType: "RECORD_DATE",
		validToDate: "9999-12-31",
		enrollingPeriod: null,
		negotiableAttributeIds: [],
		treatmentNames: "Timogel UD",
		initialVersionId: null,
		scenariosRelevantBrands: [],
		agreementTags: AgreementTagType.Custom,
	} as AgreementTemplateInput,
};

export const foCModelPayload = {
	input: {
		version: 1,
		name: `E2E Test - FoC model ${new Date().toISOString()}`,
		childAgreementsDefaultStatus: null,
		subjectMatter: "DRUGS",
		isCaseless: false,
		defaultPriceRate: 100,
		deviceAlternativeSets: [],
		hasAlternatives: false,
		validFromDate: "2021-01-01",
		validToDate: "9999-12-31",
		allowedForms: ["CR-0000000001"],
		requiredForms: ["CR-0000000001"],
		allowedRecords: ["RE-0000000001"],
		requiredRecords: [],
		isAllowedFormsEnabled: true,
		isRequiredFormsEnabled: true,
		isAllowedRecordsEnabled: true,
		isRequiredRecordsEnabled: false,
		isCoveringIntervalEnabled: false,
		currencyCode: "CHF",
		enrollingPeriod: null,
		eligibilityConditionSets: [],
		enrollingConditionSets: [
			{
				order: 0,
				conditions: [],
				scopes: [
					{
						scopeId: "AS-0000000897",
						countryScopes: [
							{
								name: "Switzerland",
								countryScopeIds: [],
							},
						],
						organizationScopes: [],
						order: 0,
						logicalOperator: "AND",
						code: "D:W59.22;I:Test type - Adjuvant;TS:G:Carbonei (13-C) Ureum,FIXED TARGET:false,P:3389,T:7680546850173;AND",
						diseases: [
							{
								Name: "Struck by turtle",
								Icd10Code: "W59.22",
								Score: null,
							},
						],
						indications: [
							{
								code: "Test type - Adjuvant",
								id: "IN-0000000172",
								type: "Test type",
								intent: "Adjuvant",
								line: null,
								mutation: null,
								typeLocalizationKey: "indication_type_testType",
								intentLocalizationKey: "indication_intent_adjuvant",
								lineLocalizationKey: null,
								mutationLocalizationKey: null,
							},
						],
						treatmentSets: [
							{
								order: 0,
								generic: "Carbonei (13-C) Ureum",
								preparations: [
									{
										id: "3389",
										AtcCode: "V04CX",
										BrandName: "Helicobacter Test Infai",
									},
								],
								treatments: [
									{
										Code: "4975",
										GTIN: "7680546850173",
										UDI: "",
										Name: "Fl 1 Stk",
										SwissmedicNo8: "54685017",
									},
								],
								isFixedPriceTarget: false,
							},
						],
						isDeleted: false,
					},
				],
				isIndicationNotEnrollingCondition: null,
				isDiseaseNotEnrollingCondition: null,
			},
		],
		cycles: [],
		treatmentPrices: [
			{
				treatment: {
					Code: "4975",
					UDI: "",
					GTIN: "7680546850173",
					Name: "Fl 1 Stk",
					SwissmedicNo8: "54685017",
					activeIngredientQuantity: null,
					uoMType: null,
				},
				price: 46.45,
				basePriceType: "PUBLIC_PRICE_PERCENT",
			} as unknown as TreatmentPriceInput,
		],
		scenarios: [
			{
				order: 0,
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "PRESCRIPTION_NUMBER",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "GREATER_THEN",
						bothOperatorFirst: null,
						bothOperatorSecond: null,
						value: 1,
						endRangeValue: null,
						brandNames: ["Helicobacter Test Infai"],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: "PACK",
						deltaType: null,
						monitoringType: null,
						startingPoint: null,
						timeframeRangeType: "EVER",
						timeframeRelation: null,
						timeframeStart: null,
						timeframeEnd: null,
						countdownPoint: null,
						comparedStartingPoint: null,
						comparedTimeframeRangeType: null,
						comparedTimeframeRelation: null,
						comparedTimeframeStart: null,
						comparedTimeframeEnd: null,
						comparedCountdownPoint: null,
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 10,
						priceType: "PUBLIC_PRICE_PERCENT",
						itemScope: "ALL",
						itemRangeType: null,
						startItemNumber: null,
						endItemNumber: null,
						timeframeRangeType: "EVER",
						timeframeStart: null,
						timeframeEnd: null,
						timeframeRelation: null,
						startingPoint: null,
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [{ name: "Helicobacter Test Infai", order: 0 }],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
					},
				],
			},
		],
		financialSummaryConfig,
		ldlChartConfig: [],
		dotChartConfig: [],
		dotThresholds: [],
		expectedDocument: "FREE_OF_CHARGE",
		id: null,
		limitationId: null,
		caseSuspensionIntervalDays: 0,
		coveringFormWaitInterval: null,
		enrolmentDateType: "RECORD_DATE",
		negotiableAttributeIds: [],
		treatmentNames: "Helicobacter Test Infai",
		initialVersionId: null,
		scenariosRelevantBrands: [],
		agreementTags: AgreementTagType.Custom,
	} as AgreementTemplateInput,
};

export const refundInvoiceModelPayload = {
	input: {
		version: 1,
		name: `E2E Test - Refund Invoice ${new Date().toISOString()}`,
		subjectMatter: "DRUGS",
		isCaseless: false,
		currencyCode: "CHF",
		validFromDate: "2021-01-01",
		allowedForms: ["CR-0000000001", "CB-0000000003"],
		requiredForms: ["CR-0000000001"],
		deviceAlternativeSets: [],
		hasAlternatives: false,
		allowedRecords: ["RE-0000000002"],
		requiredRecords: [],
		cycles: [],
		isAllowedFormsEnabled: true,
		isRequiredFormsEnabled: true,
		isAllowedRecordsEnabled: true,
		isRequiredRecordsEnabled: false,
		isCoveringIntervalEnabled: false,
		enrollingConditionSets: [
			{
				order: 0,
				conditions: [],
				scopes: [
					{
						countryScopes: [
							{
								name: "Switzerland",
								countryScopeIds: [],
							},
						],
						organizationScopes: [],
						order: 0,
						logicalOperator: "AND",
						code: "D:W58.02;I:Refractory;TS:G:Kalii chloridum,FIXED TARGET:false,P:20235,T:7680584200039;AND",
						diseases: [
							{
								Name: "Struck by alligator",
								Icd10Code: "W58.02",
							},
						],
						indications: [
							{
								code: "Refractory",
								id: null,
								type: "Refractory",
								intent: null,
								line: null,
								mutation: null,
								typeLocalizationKey: "indication_type_refractory",
								intentLocalizationKey: null,
								lineLocalizationKey: null,
								mutationLocalizationKey: null,
							},
						],
						treatmentSets: [
							{
								order: 0,
								generic: "Kalii chloridum",
								preparations: [
									{
										id: "20235",
										AtcCode: "A06AD65",
										BrandName: "Movicol aromafrei",
									},
								],
								treatments: [
									{
										Code: "23909",
										GTIN: "7680584200039",
										UDI: "",
										Name: "Btl 100 Stk",
										SwissmedicNo8: "58420003",
									},
								],
								isFixedPriceTarget: false,
							},
						],
						isDeleted: false,
					},
				],
			},
		],
		eligibilityConditionSets: [],
		treatmentPrices: [
			{
				treatment: {
					Code: "23909",
					UDI: "",
					GTIN: "7680584200039",
					Name: "Btl 100 Stk",
					SwissmedicNo8: "58420003",
					activeIngredientQuantity: null,
					uoMType: null,
				},
				price: 47.2,
				basePriceType: "PUBLIC_PRICE_PERCENT",
			} as unknown as TreatmentPriceInput,
		],
		scenarios: [
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "PRESCRIPTION_NUMBER",
						treatmentDurationAspect: null,
						discontinuationReason: null,
						patientScope: "PER_PATIENT",
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: "GREATER_THEN",
						bothOperatorFirst: null,
						bothOperatorSecond: null,
						value: 1,
						endRangeValue: null,
						brandNames: ["Movicol aromafrei"],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: "PACK",
						deltaType: null,
						monitoringType: null,
						startingPoint: null,
						timeframeRangeType: "EVER",
						timeframeRelation: null,
						timeframeStart: null,
						timeframeEnd: null,
						countdownPoint: null,
						comparedStartingPoint: null,
						comparedTimeframeRangeType: null,
						comparedTimeframeRelation: null,
						comparedTimeframeStart: null,
						comparedTimeframeEnd: null,
						comparedCountdownPoint: null,
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 20,
						priceType: "PUBLIC_PRICE_PERCENT",
						itemScope: "ALL",
						itemRangeType: null,
						startItemNumber: null,
						endItemNumber: null,
						timeframeRangeType: "EVER",
						timeframeStart: null,
						timeframeEnd: null,
						timeframeRelation: null,
						startingPoint: null,
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [{ name: "Movicol aromafrei", order: 0 }],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "PRESCRIBED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
					},
				],
				order: 0,
			},
		],
		defaultPriceRate: 100,
		childAgreementsDefaultStatus: null,
		financialSummaryConfig,
		ldlChartConfig: [],
		dotChartConfig: [],
		dotThresholds: [],
		expectedDocument: "INVOICE",
		id: null,
		limitationId: null,
		caseSuspensionIntervalDays: 0,
		coveringFormWaitInterval: null,
		enrolmentDateType: "RECORD_DATE",
		validToDate: "9999-12-31",
		enrollingPeriod: null,
		negotiableAttributeIds: [],
		treatmentNames: "Movicol aromafrei",
		initialVersionId: null,
		scenariosRelevantBrands: [],
		agreementTags: AgreementTagType.Custom,
	} as AgreementTemplateInput,
};

export const versioningDiagnosisDateModelPayload = {
	input: {
		version: 1,
		name: "E2E Versions - Diagnosis date",
		subjectMatter: "DRUGS",
		isCaseless: false,
		currencyCode: "CHF",
		validFromDate: "2020-01-01",
		allowedForms: ["EE-9999999904"],
		requiredForms: ["EE-9999999904"],
		deviceAlternativeSets: [],
		hasAlternatives: false,
		allowedRecords: ["RE-0000000001"],
		requiredRecords: [],
		cycles: [],
		isAllowedFormsEnabled: true,
		isRequiredFormsEnabled: true,
		isAllowedRecordsEnabled: true,
		isRequiredRecordsEnabled: false,
		isCoveringIntervalEnabled: false,
		enrollingConditionSets: [
			{
				order: 0,
				conditions: [],
				scopes: [
					{
						countryScopes: [
							{
								name: "Switzerland",
								countryScopeIds: [],
							},
						],
						organizationScopes: [],
						order: 0,
						logicalOperator: "AND",
						code: "D:G56.90;I:Paroxysmal - Adjuvant;TS:G:Methotrexatum,FIXED TARGET:false,P:30523,T:7680667800019;AND",
						diseases: [
							{
								Name: "Unspecified mononeuropathy of unspecified upper limb",
								Icd10Code: "G56.90",
							},
						],
						indications: [
							{
								code: "Paroxysmal - Adjuvant",
								id: "IN-0000000097",
								type: "Paroxysmal",
								intent: "Adjuvant",
								line: null,
								mutation: null,
								typeLocalizationKey: "indication_type_paroxysmal",
								intentLocalizationKey: "indication_intent_adjuvant",
								lineLocalizationKey: null,
								mutationLocalizationKey: null,
							},
						],
						treatmentSets: [
							{
								order: 0,
								generic: "Methotrexatum",
								preparations: [
									{
										id: "30523",
										AtcCode: "L04AX03",
										BrandName: "Methotrexat Accord",
									},
								],
								treatments: [
									{
										Code: "39375",
										GTIN: "7680667800019",
										UDI: "",
										Name: "Fertspr 0.150 ml",
										SwissmedicNo8: "66780001",
									},
								],
								isFixedPriceTarget: false,
							},
						],
						isDeleted: false,
					},
				],
			},
		],
		eligibilityConditionSets: [],
		treatmentPrices: [
			{
				treatment: {
					Code: "39375",
					UDI: "",
					GTIN: "7680667800019",
					Name: "Fertspr 0.150 ml",
					SwissmedicNo8: "66780001",
					activeIngredientQuantity: null,
					uoMType: null,
				},
				price: 1500,
				basePriceType: "CUSTOM_PRICE_PERCENT",
			} as unknown as TreatmentPriceInput,
		],
		scenarios: [
			{
				operator: "AND",
				isProRating: false,
				isGrouped: false,
				group: null,
				conditions: [
					{
						order: 0,
						conditionType: "TREATMENT_DURATION",
						treatmentDurationAspect: "LASTED",
						discontinuationReason: null,
						patientScope: null,
						consideredRating: null,
						consideredSecInterventionRate: null,
						intervention: null,
						reintervention: null,
						occurence: null,
						operator: null,
						bothOperatorFirst: null,
						bothOperatorSecond: null,
						value: null,
						endRangeValue: null,
						brandNames: ["Methotrexat Accord"],
						treatments: [],
						genericNames: [],
						responseType: null,
						responseInclusionType: null,
						conditionStatus: [],
						adverseEvents: [],
						grades: [],
						rollingRangeType: null,
						uoMType: null,
						deltaType: null,
						monitoringType: null,
						startingPoint: "FIRST_ADMINISTRATION_DATE",
						timeframeRangeType: "EVER",
						timeframeRelation: "STARTING_FROM",
						timeframeStart: 90,
						timeframeEnd: null,
						countdownPoint: null,
						comparedStartingPoint: null,
						comparedTimeframeRangeType: null,
						comparedTimeframeRelation: null,
						comparedTimeframeStart: null,
						comparedTimeframeEnd: null,
						comparedCountdownPoint: null,
					},
				],
				actions: [
					{
						order: 0,
						actionType: "DEDUCT",
						isAdHocDiscount: false,
						value: 50,
						priceType: "CUSTOM_PRICE_PERCENT",
						itemScope: "ALL",
						itemRangeType: null,
						startItemNumber: null,
						endItemNumber: null,
						timeframeRangeType: "EVER",
						timeframeStart: null,
						timeframeEnd: null,
						timeframeRelation: null,
						startingPoint: null,
						itemCombinationRule: "INDEPENDENTLY",
						itemCombinationRelation: null,
						combinedItemTimeframeRangeType: null,
						combinedItemTimeframeStart: null,
						combinedItemTimeframeEnd: null,
						brandNames: [{ name: "Methotrexat Accord", order: 0 }],
						treatments: [],
						genericNames: [],
						combinedItemBrandNames: [],
						combinedItemTreatments: [],
						combinedItemGenericNames: [],
						recordNature: "ADMINISTERED",
						rollingRangeType: null,
						uoMType: null,
						packOptionType: "WHOLE",
						entityPriceType: "PACK",
						ingredientEndItemNumber: null,
						ingredientRangeType: null,
						ingredientStartItemNumber: null,
						actionLogicalOperator: "OF",
						cycleOrder: null,
					},
				],
				order: 0,
			},
		],
		defaultPriceRate: 100,
		childAgreementsDefaultStatus: null,
		financialSummaryConfig,
		ldlChartConfig: [],
		dotChartConfig: [],
		dotThresholds: [],
		expectedDocument: "INVOICE",
		validToDate: "2020-12-31",
		id: null,
		limitationId: null,
		caseSuspensionIntervalDays: 0,
		coveringFormWaitInterval: null,
		enrolmentDateType: "DIAGNOSIS_DATE",
		enrollingPeriod: null,
		negotiableAttributeIds: [],
		treatmentNames: "Methotrexat Accord",
		initialVersionId: null,
		scenariosRelevantBrands: [],
		agreementTags: AgreementTagType.Custom,
	} as AgreementTemplateInput,
};
